/**
 * Shared focus ring style using semantic action tokens.
 * The actual CSS is defined as a Tailwind plugin in the studio-design-system preset.
 * Apply directly in Tailwind class lists.
 *
 * @example
 * ```tsx
 * import { focusRing } from '@repo/studio-design-system/utilities'
 * <button className={tw('...', focusRing)}>Click</button>
 * ```
 */
export const focusRing = 'focus-ring'
